import { render } from "./NewsItem.vue?vue&type=template&id=66ef1004&scoped=true"
import script from "./NewsItem.vue?vue&type=script&lang=js"
export * from "./NewsItem.vue?vue&type=script&lang=js"

import "./NewsItem.vue?vue&type=style&index=0&id=66ef1004&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1534962742/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66ef1004"]])

export default __exports__